<template>
  <div class="info-wrapper">
    <SectionTitle :title="title" subtitle="販售情報" />
    <div class="info">
      <div class="info__row">
        <div class="info__row_title">
          <div class="item">正式售價</div>
          <hr />
          <div class="price">NT.300</div>
        </div>
        <div class="detail">
          <div class="info__row_description">
            <div>12/19｜妖言惑咒｜咒術迴戰Only</div>
            <div class="brand">A25｜暗星頻道</div>
          </div>
          <Button
            content="攜量調查"
            @click.native="handleClick('https://forms.gle/kcMZTRXebSzEgaDZA')"
          />
        </div>
      </div>
      <div class="info__row">
        <div class="info__row_title">
          <div class="item">通販預購</div>
          <hr />
          <div class="price">NT.280</div>
        </div>
        <div class="detail">
          <div class="info__row_description">即日起線上預購至12/19。</div>
          <Button
            content="賣貨便"
            @click.native="
              handleClick(
                'https://myship.7-11.com.tw/general/detail/GM2008111813160'
              )
            "
          />
        </div>
      </div>
      <div class="info__row">
        <div class="info__row_title">
          <div class="item">電子書</div>
          <hr />
          <div class="price">NT.160</div>
        </div>
        <div class="detail">
          <div class="info__row_description"></div>
          <Button
            content="BOOKY"
            @click.native="
              handleClick('https://www.doujin.com.tw/books/info/57269')
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from "./SectionTitle.vue";
import Button from "./Button.vue";
export default {
  components: {
    SectionTitle,
    Button,
  },
  data() {
    return {
      title: ["INFO."],
    };
  },
  methods: {
    handleClick(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.info-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  @media (min-width: 768px) {
    align-items: flex-end;
  }
}

.info {
  margin: 15px 20px 0 20px;
  color: #fff;

  @media (min-width: 768px) {
    margin: 30px 70px 0 0;
    align-items: flex-end;
    margin: 30px 70px 0 0;
    width: 50vw;
  }
  @media (min-width: 1200px) {
    margin: 36px 31px 0 0;
    width: 70vw;
  }

  & > div + div {
    margin-top: 32px;
  }

  &__row {
    width: 100%;
    position: relative;

    &_title {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      hr {
        flex: 0.9;
        height: 3px;
        background: #000;
        border: 0;
        transform: translate(0, -50%);
      }
      .item {
        font-size: 18px;
        line-height: 25px;
        transform: translate(0, -25%);
        @media (min-width: 768px) {
          font-size: 36px;
          line-height: 49px;
          transform: translate(0, 0);
        }
      }
      .price {
        font-style: italic;
        font-weight: 100;
        font-size: 28px;
        line-height: 38px;
        @media (min-width: 768px) {
          font-size: 48px;
          line-height: 65px;
        }
        @media (min-width: 768px) {
          font-size: 72px;
          line-height: 98px;
        }
      }
    }

    .detail {
      @media (min-width: 768px) {
        display: flex;
        justify-content: space-between;
      }
    }
    &_description {
      font-size: 12px;
      line-height: 16px;
      margin-top: 8px;
      @media (min-width: 768px) {
        font-size: 18px;
        line-height: 24px;
      }
      @media (min-width: 1200px) {
        font-size: 24px;
        line-height: 32px;
      }
      .brand {
        font-size: 24px;
        line-height: 32px;
        margin-top: 4px;
        @media (min-width: 768px) {
          font-size: 38px;
          line-height: 54px;
        }
      }
    }

    .button {
      margin-top: 8px;
      @media (min-width: 768px) {
        font-weight: bold;
        font-size: 20px;
        line-height: 27px;
        padding: 10px 24px;
        height: fit-content;
        width: fit-content;
        justify-self: flex-end;
      }
      @media (min-width: 1200px) {
        font-size: 32px;
        line-height: 44px;
        padding: 16px 32px;
      }
    }
  }
}
</style>
